/**
 * Limites de taille d'upload des médias, alignées sur le convertisseur
 * (inventozen-converter/src/routes/uploadV3Routes.js) :
 *  - Vidéo : VIDEO_MAX_SIZE_MB (env, défaut 100 Mo) — route `/video`.
 *  - Image : multer fileSize 2048 Mo (2 Go) — route `/`.
 */
export const VIDEO_MAX_SIZE_MB = 100;
export const IMAGE_MAX_SIZE_MB = 2048;

/** Format court et lisible : "2 Go" au-delà de 1 Go, sinon "100 Mo". */
export function formatMaxUploadSize(sizeInMb: number): string {
  if (sizeInMb < 1024) {
    return `${sizeInMb} Mo`;
  }
  const sizeInGb = sizeInMb / 1024;
  return Number.isInteger(sizeInGb)
    ? `${sizeInGb} Go`
    : `${sizeInGb.toFixed(1)} Go`;
}
